// 객실 주소 대문자 변환 (b1223 -> B1223)
export const formatRoomAddress = (address: string | undefined): string => {
  if (!address) return '';
  return address.toUpperCase();
};

// 타입 첫글자 대문자 변환 (deluxe twin -> Deluxe Twin)
export const formatRoomType = (type: string | undefined): string => {
  if (!type) return '-';
  return type
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
};

// DB 시간을 그대로 표시 (DB에 KST로 저장되어 있음)
// 서버에서 getKstDateForPrisma()로 KST 저장하므로, 클라이언트는 변환 없이 표시
export const formatDbTime = (dateString: string | undefined | null, formatStr: string = 'MM-dd HH:mm'): string => {
  if (!dateString) return '';

  // ISO 문자열에서 날짜/시간 부분만 추출 (시간대 변환 없이)
  // "2025-12-14T15:21:23.000Z" 또는 "2025-12-14 15:21:23" 형식 처리
  const match = dateString.match(/(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2})/);
  if (!match) return dateString;

  const [, year, month, day, hour, minute] = match;

  // 포맷에 따라 반환
  switch (formatStr) {
    case 'MM-dd HH:mm':
      return `${month}-${day} ${hour}:${minute}`;
    case 'HH:mm':
      return `${hour}:${minute}`;
    case 'yyyy-MM-dd HH:mm':
      return `${year}-${month}-${day} ${hour}:${minute}`;
    case 'yyyy년 MM월 dd일':
      return `${year}년 ${month}월 ${day}일`;
    default:
      return `${month}-${day} ${hour}:${minute}`;
  }
};
